








import Vue, { PropType } from 'vue'
import filters from '@/utility/filters'
import HiddenInput from '@/types/HiddenInput.interface'
import HiddenInputComponent from '@/components/HiddenInput.vue'
import Person from '@/types/Person.interface'
export default Vue.extend({
    components: { 'hidden-input': HiddenInputComponent },
    props: {
        person: {
            type: Object as PropType<Person>,
            required: true
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        items(): HiddenInput[] {
            return [
                {
                    name: 'First Name',
                    icon: 'mdi-account',
                    iconClass: 'pr-3',
                    iconColor: 'black',
                    value: this.person.name_given,
                    validate: 'max:55',
                    fontColor: this.$colors.mdPurple,
                    fontClass: 'subtitle-1',
                    placeholder: 'First Name',
                    callback: (val: string) => (this.person.name_given = val)
                },
                {
                    name: 'Last Name',
                    icon: 'mdi-account',
                    iconClass: 'pr-3',
                    iconColor: 'black',
                    value: this.person.name_family,
                    validate: 'max:55',
                    fontColor: this.$colors.mdPurple,
                    fontClass: 'subtitle-1',
                    placeholder: 'Last Name',
                    callback: (val: string) => (this.person.name_family = val)
                },
                {
                    name: 'Mobile Phone',
                    icon: 'mdi-phone',
                    iconClass: 'pr-3',
                    iconColor: 'black',
                    value: filters.phone(this.person.phone_default.free_form_number),
                    validate: 'phone',
                    fontColor: this.$colors.mdPurple,
                    fontClass: 'subtitle-1',
                    mask: '(###) ###-####',
                    filter: 'phone',
                    placeholder: 'Mobile Phone',
                    callback: (val: string) =>
                        (this.person.phone_default.free_form_number = val)
                },
                {
                    name: 'Email',
                    icon: 'mdi-email',
                    iconClass: 'pr-3',
                    iconColor: 'black',
                    value: this.person.email_default.address,
                    validate: 'max:191|email',
                    fontColor: this.$colors.mdPurple,
                    fontClass: 'subtitle-1',
                    placeholder: 'Email Address',
                    callback: (val: string) => (this.person.email_default.address = val)
                }
            ]
        }
    },
    methods: {
        //  Focus on the first input element
        focusOnFirst(): void {
            //  Get the first input
            const el = this.$refs['item-0']

            //  Focus on the input
            el[0].focusNow()
        }
    }
})
